import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OperationDetail } from '../modules/shared/model/domain/operationDetail';

@Injectable({
  providedIn: 'root'
})
export class OperationSharerService {
  reset(): void {
    this.operationDetailSource = this.createEmpty();
    this.currentOp = this.operationDetailSource.asObservable();
  }
  private operationDetailSource = this.createEmpty();
  currentOp = this.operationDetailSource.asObservable();

  
  private createEmpty(): BehaviorSubject<OperationDetail | null> {
    return new BehaviorSubject<OperationDetail | null>(null);
  }
  
  constructor() { 
    this.operationDetailSource = this.createEmpty();
    this.currentOp = this.operationDetailSource.asObservable();
  }

  /**
   * @UseWisely
   * Use it for sincronice an OperationDetail
   * between siblings components
   */
  changeOperation(op: OperationDetail) {
    this.reset();
    this.operationDetailSource.next(op);
  }

}
